var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.5px",
    height: "16.5px",
    viewBox: "0 0 16.5 16.5",
    style: {
      enableBackground: "new 0 0 16.5 16.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,2c0-0.5-0.2-1.1-0.6-1.5c-0.8-0.8-2.1-0.8-2.9,0c0,0,0,0,0,0c0,0,0,0,0,0L1.7,11.9c0,0,0,0,0,0l0,0 c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0l0,0c0,0,0,0,0,0L0,15.8C0,16,0,16.2,0.1,16.3c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0l3.7-1.6 c0,0,0,0,0,0l0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0L14.8,4.6c0,0,0,0,0,0c0,0,0,0,0,0l1-1c0,0,0,0,0,0c0,0,0,0,0,0 C16.3,3.1,16.5,2.6,16.5,2z M15.2,1.3c0.2,0.2,0.3,0.5,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7c0,0,0,0,0,0c0,0,0,0,0,0l-0.7,0.7L13,2 l0.7-0.7c0,0,0,0,0,0c0,0,0,0,0,0C14.1,0.9,14.8,0.9,15.2,1.3z M12.3,2.7l1.5,1.5l-9.5,9.5l-1.5-1.5L12.3,2.7z M2.2,13.1l1.1,1.1 l-1.9,0.8L2.2,13.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconOutlined);
export default __webpack_public_path__ + "static/media/edit-icon-outlined.04378e463dd48395d07a5e2461d5c808.svg";
export { ForwardRef as ReactComponent };